import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect } from 'react';
import s from './index.less';

export default function Fourzerofour () {
    useStyles(s);
    useEffect(() => {
        document.title = '东楚优房';
        loading();
    }, []);

    const loading = () => {
        let count = 2;
        const spanDom = document.getElementById("content-text");

        const end = setInterval(function () {
            if (count <= 1) {
                clearInterval(end);
                window.location.href = "/";
                // return false;
            }
            spanDom.innerHTML = `${count--}s`;
        }, 1000);
    }

    return (
        <div className="page-fourZeroFour">
            <img alt="" style={{ width: '350px' }} src={require("../../images/common/404.png")} />
            <p>404系统异常，页面不存在</p>
            <p className="btn" onClick={() => {
                window.location.href = "/";
                // return false;
            }}>返回首页 <span id="content-text">3s</span></p>
        </div>
    );
}